import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useUpdateResellerVerification } from "../../../apis";
import { RejectionReasons } from "../../../constants";
import {
  ResellerVerificationForm,
  ResellerVerificationFormValues
} from "../../forms";
import { UnverifiedResellerInfo } from "../../UnverifiedResellerInfo";
import { UnverifiedResellerModalProps } from "./UnverifiedResellerModal.types";

import styles from "./UnverifiedResellerModal.module.scss";

const UnverifiedResellerModal = ({
  reseller,
  isOpen,
  refetchResellers,
  onClose
}: UnverifiedResellerModalProps) => {
  const { t } = useTranslation();

  const { mutate: mutateUpdateResellerVerification } =
    useUpdateResellerVerification({
      onSuccess: () => {
        refetchResellers();
        onClose();
        toast.success(t("Reseller verification status updated successfully"));
      }
    });

  const onSubmit = ({
    resellerId,
    decision,
    rejectionReason,
    otherRejectionReason
  }: ResellerVerificationFormValues) => {
    mutateUpdateResellerVerification({
      resellerId,
      decision,
      rejectionReason:
        rejectionReason === RejectionReasons.Other
          ? otherRejectionReason
          : rejectionReason
    });
  };

  return (
    <Modal
      title={t("Verification")}
      className={styles.resellerModal}
      isOpen={isOpen}
      onClose={onClose}
      contentClassName={styles.resellerModal_content}
      footer={<></>}
    >
      <div className={styles.resellerModal_leftColumn}>
        <UnverifiedResellerInfo reseller={reseller} />
      </div>

      <div className={styles.resellerModal_rightColumn}>
        <ResellerVerificationForm
          resellerId={reseller.id}
          onSubmit={onSubmit}
        />
      </div>
    </Modal>
  );
};

export default UnverifiedResellerModal;
